import * as ActionTypes from "./../constants/actionTypes.js";

import { defaultAction } from "./../actions/defaultAction";
import { OPEN_ERROR_BOX } from "./../constants/actionTypes";

export const setCustomerProfile = (profileData) => {
  return {
    type: ActionTypes.SET_CUSTOMER_PROFILE,
    payload: {
      profileData,
    },
  };
};

export const createAccount =
  (bodyToSendToServer) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const createAccount = await remote(
        "post",
        `v3/customers`,
        bodyToSendToServer,
        "creating a user",
        dispatch
      );

      if (createAccount.message) {
        throw createAccount;
      }
      history.push("/sign-up-confirmation");
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(
        defaultAction(ActionTypes.OPEN_ERROR_BOX, {
          title: "Error Creating Account",
          message: error.message[0],
        })
      );
    }
  };

export const getSellPayments =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const data = await remote(
        "get",
        "/v3/payments/sell",
        {},
        "getting a payment information",
        dispatch
      );

      if (data.message) {
        throw data;
      }
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.FILL_SELL_PAYMENTS, data));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(
        defaultAction(OPEN_ERROR_BOX, {
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
    }
  };

export const getSellPayment =
  (id) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const data = await remote(
        "get",
        `/v3/payments/sell/${id}`,
        {},
        "getting a payment information",
        dispatch
      );

      if (data.message) {
        throw data;
      }
      dispatch(defaultAction(ActionTypes.FILL_SELL_PAYMENT, data));
    } catch (error) {
      console.log(error);
    }
  };

export const getSellOrder =
  (id) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SELL_ORDER_THUNK_RUNNING, true));
      const data = await remote(
        "get",
        `v3/orders/${id}`,
        {},
        "getting a sell order",
        dispatch
      );

      if (data.message) {
        throw data;
      }
      dispatch(defaultAction(ActionTypes.FILL_SELL_ORDER, data));
      dispatch(defaultAction(ActionTypes.SELL_ORDER_THUNK_RUNNING, false));
      dispatch(getSellOrderCards(id));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.SELL_ORDER_THUNK_RUNNING, false));
    }
  };

export const getSellOrders =
  (id) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SELL_ORDER_THUNK_RUNNING, true));
      const data = await remote(
        "get",
        "v3/orders/sell",
        {},
        "getting all sell orders",
        dispatch
      );

      if (data.message) {
        throw data;
      }
      dispatch(defaultAction(ActionTypes.FILL_SELL_ORDERS, data));
      dispatch(defaultAction(ActionTypes.SELL_ORDERS_THUNK_RUNNING, false));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.SELL_ORDER_THUNK_RUNNING, false));
    }
  };

export const getSellCards =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SELL_CARDS_THUNK_RUNNING, true));
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const data = await remote(
        "get",
        "/v3/cards/sell",
        {},
        "getting a customer orders",
        dispatch
      );

      if (data.message) {
        throw data;
      }
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.FILL_SELL_CARDS, data));
      dispatch(defaultAction(ActionTypes.SELL_CARDS_THUNK_RUNNING, false));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.SELL_CARDS_THUNK_RUNNING, false));
    }
  };

export const getSellOrderCards =
  (orderId) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SELL_CARDS_THUNK_RUNNING, true));

      const data = await remote(
        "get",
        `/v3/cards/sell?orderId=${orderId}`,
        {},
        "getting an order cards",
        dispatch
      );

      if (data.message) {
        throw data;
      }
      dispatch(defaultAction(ActionTypes.FILL_SELL_ORDER_CARDS, data));
      dispatch(defaultAction(ActionTypes.SELL_CARDS_THUNK_RUNNING, false));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.SELL_CARDS_THUNK_RUNNING, false));
    }
  };

export const getCustomerProfile =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      dispatch(defaultAction(ActionTypes.CUSTOMER_PROFILE_THUNK_RUNNING, true));
      const profileData = await remote(
        "get",
        `v3/customers`,
        {},
        "getting a customer profile",
        dispatch
      );

      if (!profileData || profileData.message) {
        throw profileData;
      }

      const isBulkSellerVerified = profileData.customer.bulkSeller;

      if (!isBulkSellerVerified) {
        dispatch(defaultAction(ActionTypes.TOGGLE_BULK_SELL_LOGIN_ERROR));
        dispatch(logoutUser());
        return;
      }

      dispatch(setCustomerProfile(profileData));
      dispatch(defaultAction(ActionTypes.CLEAR_SET_PW));
      dispatch(defaultAction(ActionTypes.CLEAR_SET_EMAIL_ADDRESS));
      dispatch(defaultAction(ActionTypes.CLEAR_SET_SIGNIN_EMAIL));
      dispatch(defaultAction(ActionTypes.CLEAR_SET_SIGNIN_PASSWORD));
      dispatch(
        defaultAction(ActionTypes.CUSTOMER_PROFILE_THUNK_RUNNING, false)
      );
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.LOGOUT));
      dispatch(
        defaultAction(ActionTypes.CUSTOMER_PROFILE_THUNK_RUNNING, false)
      );
    }
  };

export const getCustomerDefaultPaymentOptions =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const data = await remote(
        "get",
        `v3/customers/payment-options`,
        {},
        "getting customer default payment options",
        dispatch
      );

      if (data.message) {
        throw data;
      }
      dispatch(defaultAction(ActionTypes.SET_PAYMENT_OPTIONS, data.data));
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      console.log(error);
    }
  };

export const initForgotPassword =
  (email, reCaptcha, baseURI) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const data = await remote(
        "post",
        "v3/customers/password/forgot",
        { customer: { email }, reCaptcha, baseURI },
        "initForgotPassword",
        dispatch
      );

      if (data) {
        dispatch(defaultAction(ActionTypes.HIDE_FORGOT_PASSWORD));
        dispatch(defaultAction(ActionTypes.HIDE_LOADING));
        history.push("/email-sent-pass-reset");
      } else {
        throw data;
      }
    } catch (error) {
      console.log(error);
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.SHOW_ERROR_INIT_FORGOT_PASSWORD));
    }
  };

export const startVerify =
  (orderId, method) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const verify = await remote(
        "post",
        "v3/orders/" + orderId + "/phone-verify",
        { method },
        "startVerify",
        dispatch
      );

      if (verify.message) {
        throw verify;
      }

      dispatch(defaultAction(ActionTypes.SET_VERIFY_ID, verify.verifyId));
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      if (
        error.message &&
        error.message.length &&
        error.message[0] ===
          "You have exceeded the number of allowed attempts to verify your phone number. Please contact customer service."
      ) {
        dispatch(defaultAction(ActionTypes.HIDE_TWILIO_POPUP));
        dispatch(defaultAction(ActionTypes.OPEN_ATTEMPTS_EXCEEDED_BOX));
      } else {
        dispatch(
          defaultAction(
            ActionTypes.OPEN_ERROR_BOX,
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you."
          )
        );
      }
    }
  };

export const completeVerify =
  (orderId, verifyId, code, that) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const verify = await remote(
        "put",
        "v3/orders/" + orderId + "/phone-verify",
        { code: Number(code), verifyId: verifyId },
        "completeVerify",
        dispatch
      );

      if (verify.message) {
        throw verify;
      }

      dispatch(defaultAction(ActionTypes.HIDE_TWILIO_POPUP));

      if (
        that.props.location &&
        that.props.location.pathname !== "/new-order/enter-cards"
      ) {
        dispatch(getSellOrders());
        // dispatch(getMostRecentSellOrder(orderId));
      } else {
        history.push("/order-complete");
      }
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      if (!!error) {
        dispatch(
          defaultAction(ActionTypes.UPDATE_ACCOUNT_STATUS, error.message)
        );
        dispatch(
          defaultAction(ActionTypes.UPDATE_ATTEMPTS, error.message[0][15])
        );

        if (error.message[0][15] === "3" || error.message[0][8] === "6") {
          dispatch(defaultAction(ActionTypes.MAKE_ANOTHER_PASSCODE_ATTEMPT));
        }
      } else {
        dispatch(
          defaultAction(ActionTypes.UPDATE_ACCOUNT_STATUS, "Account Locked")
        );
        dispatch(defaultAction(ActionTypes.SHOW_ACCOUNT_LOCKED));
      }
    }
  };

export const cancelSellOrder =
  (id) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const cancelSellOrder = await remote(
        "put",
        `v3/orders/${id}`,
        { cancel: true },
        "Successfully cancelled a sell order",
        dispatch
      );

      if (cancelSellOrder.message) {
        throw cancelSellOrder;
      }
      dispatch(defaultAction(ActionTypes.CLOSE_CANCEL_SELL_ORDER_MODAL));
      dispatch(
        defaultAction(ActionTypes.SET_NOTIFICATION_MSG, "Order Canceled")
      );
      dispatch(defaultAction(ActionTypes.FADE_IN_CARD_ADDED));
      dispatch(refreshSellOrders());
    } catch (error) {
      dispatch(
        defaultAction(ActionTypes.OPEN_ERROR_BOX, {
          title: "Cancel order error",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.CLOSE_CANCEL_SELL_ORDER_MODAL));
      dispatch(
        defaultAction(ActionTypes.OPEN_ERROR_BOX, {
          title: "Sorry, we are experiencing technical difficulties",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
    }
  };

export const updateCustomerProfile =
  (editCustomerInfo) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      let { customerInfo } = getState();
      const { phones, addresses } = await Promise.all([
        remote(
          "post",
          "v3/customers/phones",
          {
            customerId: editCustomerInfo.id,
            phone: {
              number: editCustomerInfo.phone,
            },
          },
          "updated phone",
          dispatch
        ),
        remote(
          "post",
          "v3/customers/addresses",
          {
            customerId: editCustomerInfo.id,
            address: {
              firstname: customerInfo.get("firstname"),
              lastname: customerInfo.get("lastname"),
              street: editCustomerInfo.street,
              street2: editCustomerInfo.street2 || "",
              city: editCustomerInfo.city,
              state: editCustomerInfo.state,
              postcode: editCustomerInfo.zip,
            },
          },
          "updated addresses",
          dispatch
        ),
      ]);

      if (phones.message) {
        throw phones;
      }

      if (addresses.message) {
        throw addresses;
      }

      dispatch(getCustomerProfile());
      dispatch(defaultAction(ActionTypes.CLOSE_EDIT_PROFILE_MODAL));
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
    } catch (error) {
      dispatch(
        defaultAction(ActionTypes.OPEN_ERROR_BOX, {
          title: "Update profile error",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.CLOSE_EDIT_PROFILE_MODAL));
    }
  };

export const resetPasswordAccount =
  (newPassword, oldPassword) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const resetPasswordAccount = await remote(
        "put",
        "v3/customers/password/change",
        { customer: { oldPassword, newPassword } },
        "resetting your password",
        dispatch
      );

      if (resetPasswordAccount.message) {
        throw resetPasswordAccount;
      }
      dispatch(defaultAction(ActionTypes.CLOSE_CHANGE_PASSWORD_MODAL));
      dispatch(
        defaultAction(ActionTypes.SET_NOTIFICATION_MSG, "Password Changed")
      );
      dispatch(defaultAction(ActionTypes.FADE_IN_CARD_ADDED));
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.CLOSE_CHANGE_PASSWORD_MODAL));
      dispatch(
        defaultAction(ActionTypes.OPEN_ERROR_BOX, {
          title: "Unable to change password",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(
        defaultAction(ActionTypes.CHANGE_PASSWORD_ERR_MSG, error.message)
      );
    }
  };

export const sendSupportMsg =
  (body) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const data = await remote(
        "post",
        "v3/messages/support",
        body,
        "sending a support email to customer service",
        dispatch
      );

      if (data.message && data.message === "email was successfully sent") {
        dispatch(
          defaultAction(ActionTypes.SET_NOTIFICATION_MSG, "Message Sent")
        );
        dispatch(defaultAction(ActionTypes.FADE_IN_CARD_ADDED));
        dispatch(defaultAction(ActionTypes.CLOSE_SUPPORT_MODAL));
        dispatch(defaultAction(ActionTypes.CLOSE_SUPPORT_CARD_LEVEL_MODAL));
        dispatch(defaultAction(ActionTypes.CLOSE_HELP_OPTIONS));
        dispatch(defaultAction(ActionTypes.CLOSE_CARD_HELP_BUTTONS));
        dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      } else {
        throw data;
      }
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(
        defaultAction(ActionTypes.OPEN_ERROR_BOX, {
          title: "Server error",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.CLOSE_SUPPORT_MODAL));
      dispatch(defaultAction(ActionTypes.CLOSE_SUPPORT_CARD_LEVEL_MODAL));
      dispatch(
        defaultAction(
          ActionTypes.SHOW_ORDER_ASSISTANCE_API_ERROR,
          "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you."
        )
      );
    }
  };

export const refreshSellOrders =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const data = await remote(
        "get",
        "v3/orders/sell",
        {},
        "getting all sell orders",
        dispatch
      );

      if (data.message) {
        throw data;
      }

      dispatch(defaultAction(ActionTypes.FILL_SELL_ORDERS, data));
    } catch (error) {}
  };

export const updatePhoneNumberForOrder =
  (id, phone) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(defaultAction(ActionTypes.SHOW_LOADING));
      const data = await remote(
        "put",
        `v3/orders/${id}`,
        { phone },
        "updatePhoneNumberForOrder",
        dispatch
      );

      if (data.message) {
        throw data;
      }

      dispatch(defaultAction(ActionTypes.SET_PHONE, phone));
      dispatch(defaultAction(ActionTypes.HIDE_CHANGE_PHONE));
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
    } catch (error) {
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.DISPLAY_CHANGE_PHONE_ERROR));
    }
  };

export const contactCustomerSupport =
  (contactObj) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const data = await remote(
        "post",
        "/v3/messages/contact",
        contactObj,
        "reaching out to customer support",
        dispatch
      );

      if (data.message === "email was successfully sent") {
        history.push("/email-sent");
        dispatch(defaultAction(ActionTypes.CLEAR_CONTACT_FORM));
      } else {
        throw data;
      }
    } catch (error) {
      dispatch(
        defaultAction(ActionTypes.OPEN_ERROR_BOX, {
          title: "Sorry, we are experiencing technical difficulties",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
    }
  };

export const sendClaim =
  (body) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const orderUUID = getState().orderAssistance.get("orderUUID");
      const data = await remote(
        "post",
        "v3/claims",
        body,
        "sending a claims email to customer service",
        dispatch
      );

      if (data.message) {
        throw data;
      }
      const buyOrder = await remote(
        "get",
        `/v3/orders/${orderUUID}`,
        {},
        "getting a buy order",
        dispatch
      );
      dispatch(defaultAction(ActionTypes.FILL_BUY_ORDER, buyOrder));
      dispatch(defaultAction(ActionTypes.SET_NOTIFICATION_MSG, "Message Sent"));
      dispatch(defaultAction(ActionTypes.FADE_IN_CARD_ADDED));
      dispatch(defaultAction(ActionTypes.CLOSE_SUPPORT_CARD_LEVEL_MODAL));
      dispatch(defaultAction(ActionTypes.CLOSE_HELP_OPTIONS));
      dispatch(defaultAction(ActionTypes.CLOSE_CARD_HELP_BUTTONS));
    } catch (error) {
      dispatch(
        defaultAction(ActionTypes.OPEN_ERROR_BOX, {
          title: "Server error",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
      dispatch(defaultAction(ActionTypes.HIDE_LOADING));
      dispatch(defaultAction(ActionTypes.CLOSE_SUPPORT_CARD_LEVEL_MODAL));
      dispatch(
        defaultAction(
          ActionTypes.SET_ORDER_ASSISTANCE_API_ERROR,
          "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you."
        )
      );
    }
  };
